import axios from "axios";
import { configUrl } from "config";
import { useMutation } from "react-query";

const deleteNotificationApi = async (id) => {
    const res = await axios.delete(
        `${configUrl.AssessmentServer}/api/Notification/GlobalNotification/${id}`
    );
    return res.data;
};

export default function useDeleteNotification() {
    return useMutation(deleteNotificationApi);
}